import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: '/total',
        name: 'Total',
        component: () => import('../views/game/Total.vue')
      },
      {
        path: '/',
        name: 'GameData',
        component: () => import('../views/game/GameData.vue')
      },
      {
        path: '/gamedata',
        name: 'GameData',
        component: () => import('../views/game/GameData.vue')
      },
      {
        path: '/gamereports',
        name: 'GameReports',
        component: () => import('../views/game/GameReports.vue')
      },
      {
        path: '/costreports',
        name: 'costreports',
        component: () => import('../views/game/CostReports.vue')
      },
      {
        path: '/revenue',
        name: 'Revenue',
        component: () => import('../views/game/RevenueData.vue')
      },
      {
        path: '/patch',
        name: 'Patch',
        component: () => import('../views/game/PatchView.vue')
      },
      {
        path: '/apps',
        name: 'Apps',
        component: () => import('../views/game/Apps.vue')
      },
      {
        path: '/advertisers',
        name: 'Advertisers',
        component: () => import('../views/game/Advertisers.vue')
      },
      {
        path: '/app_gallery',
        name: 'AppGallery',
        component: () => import('../views/game/AppGallery.vue')
      },
      {
        path: '/roas/:package_name',
        name: 'Roas',
        component: () => import('../views/game/RoasData.vue')
      },
      {
        path: '/accounts',
        name: 'Accounts',
        component: () => import('../views/game/Accounts.vue')
      },
      {
        path: '/promotion',
        name: 'Promotion',
        component: () => import('../views/game/Promotion.vue'),
        children: [
          {
            path: '/',
            name: 'Tasks',
            component: () => import('../views/game/promotion/Tasks.vue'),
          },
          {
            path: '/promotion/',
            name: 'Promotion',
            component: () => import('../views/game/promotion/Budget.vue'),
          },
          {
            path: '/promotion/assets',
            name: 'Assets',
            component: () => import('../views/game/promotion/Assets.vue'),
          },
          {
            path: '/promotion/collection',
            name: 'Collection',
            component: () => import('../views/game/promotion/Collection.vue'),
          },
          {
            path: '/promotion/budget',
            name: 'Budget',
            component: () => import('../views/game/promotion/Budget.vue'),
          },
          {
            path: '/promotion/white',
            name: 'White',
            component: () => import('../views/game/promotion/White.vue'),
          }
        ]
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( '../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
